// extracted by mini-css-extract-plugin
module.exports = {"rating":"ei","numberOfStars":"fi"};